import { Button } from '@unified-lk/ui'
import type { ReactNode } from 'react'
import {
  workspaceFieldClassName,
  workspaceFieldLabelClassName,
  workspaceInputClassName,
} from '../workspaceStyles'

export function WorkspaceSearchPanel({
  label,
  value,
  placeholder,
  submitLabel = 'Найти',
  onChange,
  onSubmit,
  children,
}: {
  label: string
  value: string
  placeholder?: string
  submitLabel?: string
  onChange: (value: string) => void
  onSubmit?: () => void
  children?: ReactNode
}) {
  return (
    <div className={workspaceFieldClassName}>
      <span className={workspaceFieldLabelClassName}>{label}</span>
      <div className="flex flex-wrap gap-2.5">
        <input
          className="min-w-[240px] flex-1 rounded-[18px] border border-slate-200 bg-white px-4 py-3 text-slate-900 outline-none transition focus:border-sky-300 focus:ring-2 focus:ring-sky-100"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onSubmit?.()
            }
          }}
          placeholder={placeholder}
        />
        {children}
        {onSubmit ? <Button type="button" onClick={onSubmit}>{submitLabel}</Button> : null}
      </div>
    </div>
  )
}

export function WorkspaceSelectFilter({
  label,
  value,
  options,
  onChange,
}: {
  label: string
  value: string
  options: Array<{ value: string; label: string }>
  onChange: (value: string) => void
}) {
  return (
    <label className="grid gap-1 text-xs font-semibold text-slate-500">
      <span>{label}</span>
      <select
        className={`${workspaceInputClassName} py-2.5 text-sm`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </label>
  )
}

export function WorkspacePagination({
  page,
  pages,
  total,
  pageSize,
  itemLabel,
  onPrevPage,
  onNextPage,
}: {
  page: number
  pages: number
  total: number
  pageSize?: number
  itemLabel: string
  onPrevPage: () => void
  onNextPage: () => void
}) {
  const safePages = Math.max(pages, 1)
  const safePage = Math.min(Math.max(page, 1), safePages)
  const from = total === 0 || !pageSize ? 0 : (safePage - 1) * pageSize + 1
  const to = total === 0 || !pageSize ? total : Math.min(total, safePage * pageSize)

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button variant="secondary" type="button" onClick={onPrevPage} disabled={safePage <= 1}>Назад</Button>
      <span className="text-sm text-slate-500">
        Страница {safePage} / {safePages}
        {pageSize ? ` · ${from}-${to} из ${total} ${itemLabel}` : ` · ${total} ${itemLabel}`}
      </span>
      <Button variant="secondary" type="button" onClick={onNextPage} disabled={safePage >= safePages}>Вперед</Button>
    </div>
  )
}
